import type { SemanticTextTag } from "ca-online-design-system";

export type HeadingTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";

const headingTags: HeadingTag[] = ["h1", "h2", "h3", "h4", "h5", "h6"];
const semanticTextTags: readonly SemanticTextTag[] = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
];

export const normalizeSemanticTextTag = (
  value: unknown,
): SemanticTextTag | undefined => {
  if (typeof value !== "string") return undefined;

  const normalizedValue = value.trim().toLowerCase();
  if (!normalizedValue) return undefined;

  const tag = normalizedValue === "paragraph" ? "p" : normalizedValue;

  return semanticTextTags.includes(tag as SemanticTextTag)
    ? (tag as SemanticTextTag)
    : undefined;
};

export function normalizeHeadingTag(
  value: unknown,
  fallback: HeadingTag = "h2",
): HeadingTag {
  const normalized = String(value ?? "").trim().toLowerCase();

  if (normalized === "paragraph" || normalized === "p") return "p";
  if (headingTags.includes(normalized as HeadingTag)) {
    return normalized as HeadingTag;
  }
  if (/^[1-6]$/.test(normalized)) return `h${normalized}` as HeadingTag;

  return fallback;
}